import { Action } from 'redux';

export const PURCHASES_TOGGLE_OFFER = 'purchases/toggle_offer';
export const PURCHASES_CLEAR_CART = 'purchases/clear_cart';

interface PurchasesToggleOfferAction extends Action<typeof PURCHASES_TOGGLE_OFFER> {
    payload: {
        petUuid: string;
        offerId: string;
    };
}

interface PurchasesClearCartAction extends Action<typeof PURCHASES_CLEAR_CART> {}

export type PurchasesAction = PurchasesToggleOfferAction | PurchasesClearCartAction;
